export default __webpack_public_path__ + "static/media/flag-fbi.27b132c2.svg";